import axios from 'axios';

export const getPageMode = () => axios.get('dev/GetPageMode');

export const getEnvironments = () => axios.get('dev/GetEnvironments');

export const getPortals = environmentId => axios.post('dev/GetPortals', { environmentId });

export const getPages = (portalId) => axios.post('dev/GetAllPages', { portalId });

export const getPageByName = (portalId, name) => axios.post('dev/GetPagesByName', { portalId, name });

export const getConfigLayout = (portalId) => axios.post('dev/GetConfigLayout', { portalId });

export const saveConfigLayout = (portalId, file) => axios.post('dev/SaveConfigLayout', { portalId, file });

export const getMenus = (portalId) => axios.post('dev/GetMenus', { portalId });

export const createMenu = (menu, portalId) => axios.post('dev/CreateMenu', { menu, portalId });

export const updateMenu = (menu, portalId) => axios.post('dev/UpdateMenu', { menu, portalId });

export const deleteMenu = (id, portalId) => axios.post('dev/DeleteMenu', { id, portalId });

export const saveOrderMenu = (portalId, listMenu) => axios.post('dev/SaveOrderMenu', { portalId, listMenu });

export const savePage = (portalId, file, name) => axios.post('dev/SavePage', { portalId, file, name });
